import { StandardLuminance } from "@fluentui/web-components";
import { DesignSystemProvider } from "@microsoft/fast-foundation";
import { rgbToRelativeLuminance, parseColorHexRGB, parseColorWebRGB, } from "@microsoft/fast-colors";
import { Observable, } from "@microsoft/fast-element";
import { memoize } from "lodash-es";
/**
 * This is recreated because we could not use 'parseColorString' from 'fluent/web-components' to 'rgbToRelativeLuminance' because there is a type mismatch with 'ColorRGBA64'
 */
const parseColorString = memoize((color) => {
    let parsed = parseColorHexRGB(color);
    if (parsed !== null) {
        return parsed;
    }
    parsed = parseColorWebRGB(color);
    if (parsed !== null) {
        return parsed;
    }
    throw new Error(`${color} cannot be converted to a ColorRGBA64. Color strings must be one of the following formats: "#RGB", "#RRGGBB", or "rgb(r, g, b)"`);
});
/**
 * This is recreated because 'luminance' is not exported
 */
function luminance(color) {
    return rgbToRelativeLuminance(parseColorString(color));
}
export class LuminanceStyleSheetBehavior {
    constructor(light, dark) {
        this.cache = new WeakMap();
        this.light = light;
        this.dark = dark;
    }
    /**
     * @internal
     */
    bind(source) {
        const provider = DesignSystemProvider.findProvider(source);
        if (provider !== null) {
            if (provider.$fastController && provider.$fastController.isConnected) {
                this.attach(source, provider);
            }
            else {
                if (!Array.isArray(provider.disconnectedRegistry)) {
                    provider.disconnectedRegistry = [];
                }
                provider.disconnectedRegistry.push(this.attach.bind(this, source));
            }
        }
    }
    /**
     * @internal
     */
    unbind(source) {
        const cache = this.cache.get(source);
        if (cache) {
            Observable.getNotifier(cache[0].designSystem).unsubscribe(cache[1]);
        }
    }
    attach(source, provider) {
        const subscriber = new LuminanceStyleSheetBehaviorSubscription(this.light, this.dark, source);
        Observable.getNotifier(provider.designSystem).subscribe(subscriber, "backgroundColor");
        subscriber.attach(provider.designSystem["backgroundColor"]);
        this.cache.set(source, [provider, subscriber]);
    }
}
/**
 * Subscription for {@link LuminanceStyleSheetBehavior}
 */
class LuminanceStyleSheetBehaviorSubscription {
    constructor(light, dark, source) {
        this.light = light;
        this.dark = dark;
        this.source = source;
        this.attached = null;
    }
    handleChange(source) {
        this.attach(source.backgroundColor);
    }
    attach(backgroundColor) {
        const theme = luminance(backgroundColor) <= StandardLuminance.DarkMode ? "dark" : "light";
        if (this.attached !== this[theme]) {
            if (this.attached !== null) {
                this.source.$fastController.removeStyles(this.attached);
            }
            this.attached = this[theme];
            if (this.attached !== null) {
                this.source.$fastController.addStyles(this.attached);
            }
        }
    }
}
